import Vue from 'vue';
import './element';
import axios from "axios";
import notification_header from './components/EshopNotificationsHeader';
import notification_footer from './components/EshopNotificationsFooter';


import VueRouter from 'vue-router';
Vue.use(VueRouter);
Vue.component('treeselect', require('@riophae/vue-treeselect').default);
Vue.component('group-filter', require('./components/GroupFilter.vue').default);

new Vue({
    el: '#shop-app',
    router: new VueRouter({
        mode: 'history'
    }),

    components : {notification_header, notification_footer},

    data: {
        exportUrl : window.location.pathname,
        filters: [],
        tableData: [],
        dataWarehouse: [],
        dataReserved: -1,
        dataSp : [],
        dataDa : [],
        userData: window.userData,
        errors: {},
        loading: false,
     //   comp: 'account',
        saved: false,
        message: '',
        tableLoading : false,
        totalRows : 0
    },

    watch: {
        '$route'(to, from) {
            this.setDataFromQueryParams();
            this.updateData();
        }
    },

    methods: {
        resetFilters: function () {
            this.$router.replace(window.location.pathname);
            this.$refs.table.clearSort();
            this.$toasted.global.success($r.shop_filter_cleared);
            this.$nextTick(() => {
                this.$refs.clearFilterButton.$el.blur();
            });
            this.currentFilterName = null;
        },

        changedReserved: function (val) {
            var q = _.merge({}, this.$route.query);
            delete q['re'];
            if (val >= 0) {
                q.re = val;
            }
            q.pg = 1;
            this.$router.replace({
                query: q
            });
        },

        changedWarehouse: function (val) {
            var q = _.merge({}, this.$route.query);
            q.wh = val;
            q.pg = 1;
            this.$router.replace({
                query: q
            });
        },
        changedSp: function (val) {
            var q = _.merge({}, this.$route.query);
            q.sp = val;
            q.pg = 1;
            this.$router.replace({
                query: q
            });
        },
        changedDa: function (val) {
            var q = _.merge({}, this.$route.query);
            q.da = val;
            q.pg = 1;
            this.$router.replace({
                query: q
            });
        },

        getDecSep : function(locale_) {
            var n = 1.1;
            n = n.toLocaleString(locale_).substring(1, 2);
            return n;
        },

        setDataFromQueryParams: function () {
            this.dataWarehouse = _.concat([], this.$route.query.wh);
            this.dataSp = _.concat([], this.$route.query.sp);
            this.dataDa = _.concat([], this.$route.query.da);
            if (typeof this.$route.query.re == 'undefined')
                this.dataReserved = -1;
            else
                this.dataReserved = parseInt(this.$route.query.re);
        },

        tableFormatter: function (row, column, cellValue, index) {
            try {
                switch (column.property)
                {
                    default:
                        return cellValue;
                    break;
                }
            } catch (error) {
                console.error(error);
                return cellValue;
            }
        },
        sortTable: function (params) {
            var q = _.merge({}, this.$route.query);
            delete q['by'];
            delete q['or'];
            if (params.order && params.prop) {
                // Kaut kāds ElementUI bugs, kur spiežot ar peli ir strings,
                // bet manuāli izsaucot sortēšanu .prop ir objekts ar vērtībām
                // if(typeof params.prop == 'object') {
                //     q.by = params.prop.prop;
                // } else {
                //     q.by = params.prop;
                // }
                q.by = params.prop;
                var order = 'asc';
                if (params.order == 'descending') {
                    order = 'desc';
                }
                q.or = order;
            }
            this.$router.replace({
                query: q
            });
        },
        save() {
        },
        showMessage(msg) {
            this.message = msg;
            //this.comp = 'message';
        },
        updateData: function () {
            var $this = this;
            this.tableLoading = true;
            axios.get('/' + window.lang + '/shop/open-remains/data' + window.location.search)
                .then(response => {
                    $this.filters = response.data.filters;
                    $this.tableData = response.data.products;
                    $this.totalRows = response.data.products_total;
                    $this.setDataFromQueryParams();
                })
                .catch(err => {
                    console.error(err);
                }).then(() => {
                $this.tableLoading = false;
                $this.exportUrl = '/' + window.lang + '/shop/open-remains/export/' + window.location.search + (window.location.search.length == 0 ? '?' : '&') +'sep=' + $this.getDecSep(window.lang);
            });
        },
    },
    computed: {
        tableDefaultSort: function () {
            var order = { prop: 'title', order: 'ascending' };
            if (this.$route.query.by && this.$route.query.or) {
                var o = 'ascending';
                if (this.$route.query.or == 'desc') {
                    o = 'descending';
                }
                order = { prop: this.$route.query.by, order: o };
            }
            return order;
        },
        cartCount() {
            return window.cartCount;
        }
    },
    mounted : function (){
        this.updateData();
    }
});
